export { default as validationsStore } from "./validations.store";



// WEBPACK FOOTER //
// ./src/modules/validations/index.ts